import React from 'react'
import { ChevronDownIcon } from '@fluentui/react-icons-mdl2'
import cn from 'classnames'

import Hit from 'components/Filters/types/Hit'

import styles from './MenuItem.module.css'

type MenuItemProps = {
  item: Hit
  onClick: () => void
  currentRefinement: string
}

const MenuItem = ({
  item,
  onClick,
  currentRefinement,
}: MenuItemProps): JSX.Element => (
  <div
    className={cn(styles.item, {
      [styles.refined]: currentRefinement
        ?.split(' > ')
        .some((member) => member === item.label),
    })}
  >
    <div onClick={onClick} role="button" tabIndex={0} className={styles.label}>
      <span className={styles.text}>{item.label}</span>
      <span className={styles.count}>({item.count})</span>
    </div>

    {item.items && (
      <div className={styles.arrow}>
        <ChevronDownIcon />
      </div>
    )}
  </div>
)

export default MenuItem
